<template>
  <div class="loginContainer">
    <contentgroup-com>
      <div class="login">
        <div class="login-fields">
          <div class="login-input">
            <div class="login-inputLabel">
              Username
            </div>
            <input type="text" v-model="username">
          </div>
          <div class="login-fieldsDivider"></div>
          <div class="login-input">
            <div class="login-inputLabel">
              Password
            </div>
            <input type="password" v-model="password">
          </div>
        </div>
        <div class="login-button">
          <button-com
            text="Login"
            @click.native="login"
          ></button-com>
        </div>
      </div>
    </contentgroup-com>
  </div>
</template>

<script>
export default {
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    login () {
      this.$http.post(
        'http://api.lootbox.se/login',
        {
          username: this.username,
          password: this.password
        },
        {
          emulateJSON: true,
          withCredentials: true
        }
      ).then(({body}) => {
        this.username = ''
        this.password = ''

        if (!body) {
          return
        }

        this.$store.commit({
          type: 'userInfo',
          name: body.name,
          organisation: body.organisation
        })

        if (body.feeds.length) {
          this.$store.commit('feeds', body.feeds)
        }

        this.$store.commit('currentFeed', 0)
      }, () => {
        console.log('Fail!')
      })
    }
  }
}
</script>

<style lang="sass">
@import './../sass/core.sass'

+block('loginContainer')
  position: fixed
  width: 100%
  height: 100%
  display: flex
  align-items: center

+block('login')
  width: 100%

  +element('fields')
    display: flex
    margin-bottom: 30px

  +element('input')
    width: 100%

  +element('inputLabel')
    padding-top: 9px
    padding-left: 25px
    text-transform: capitalize
    font-size: 12px
    margin-bottom: 12px

  +element('fieldsDivider')
    width: 30px

  +element('button')
    width: 200px

</style>



// WEBPACK FOOTER //
// src/views/Login.vue